import VanillaTilt from 'vanilla-tilt';

const TILT_BREAKPOINT = 1032;
const mql = window.matchMedia(`(min-width: ${TILT_BREAKPOINT + 1}px)`);

function initTilt() {
  console.log(12334)
  const elements = document.querySelectorAll('[data-tilt]');
  elements.forEach(el => {
    if (el.vanillaTilt) return; // уже инициализирован

    // Собираем настройки из data-атрибутов (VanillaTilt.init делает это сам)
    VanillaTilt.init(el);
  });
}

function destroyTilt() {
  const elements = document.querySelectorAll('[data-tilt]');
  elements.forEach(el => {
    if (el.vanillaTilt) {
      el.vanillaTilt.destroy();
    }
  });
}

function handleBreakpoint(e) {
  if (e.matches) {
    initTilt();
  } else {
    destroyTilt();
  }
}

// Инициализация: проверяем текущее состояние
if (mql.matches) {

  initTilt();
} else {
  destroyTilt();
}

// Слушаем изменение — единственный listener, кэшированный matchMedia
mql.addEventListener('change', handleBreakpoint);